import { Checkbox, Col, Row, Spin } from 'antd'
import Button from 'components/Button/index'
import RadioButton from 'components/Form/Radio'
import DeleteIcon from 'components/icons/Delete'
import PlusIcon from 'components/icons/PlusIcon'
import Select, { FormItem } from 'components/Select'
import { Form, RadioGroup } from 'components/UIComponents/FormStyles'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import ArrowDownIcon from '../../../../../../components/icons/ArrowDownIco'
import { EmptyDivElement } from '../../../../../../components/UIComponents/CommonStyledComponent'

import Debounce from '../../../../../../utils/Debounce'
import {
  checkFormatNumber,
  convertToNumber,
  formatNumber,
  getPlacedStatus,
} from '../../../RuleEngineCommonFunction'
import { RuleContext } from '../../RulesCreationTable'
import {
  CheckBoxContainer,
  NormalTable,
  StyledHr,
  StyledInputNumber,
  StyledRuleCol,
  StyledRuleRow,
  StyledSymbolWithIcon,
  StyledTextInput,
  TextElement,
} from '../../style'
const placedStatusOption = [
  {
    id: 2,
    label: 'Intent to Offer',
    value: 'INTENT_TO_OFFER',
  },
  {
    id: 1,
    label: 'Offer Acceptance',
    value: 'OFFER_ACCEPTED',
  },
]

const positionBasedOption = [
  {
    id: 2,
    label: 'Allow',
    value: true,
  },
  {
    id: 1,
    label: `Don't Allow`,
    value: false,
  },
]

export default function ApplicationThreshold() {
  const {
    ruleForm,
    setState,
    state: { applicationStatusThreshold },
    state,
    getListOfCompanies,
  } = useContext(RuleContext)
  const [loading, setLoading] = useState(false)
  const [corporateList, setCorporateList] = useState([])

  const isMultiplesLPA =
    applicationStatusThreshold?.isMultiples &&
    !!applicationStatusThreshold?.placementType
  const isAbsoluteLAP =
    applicationStatusThreshold?.isAbsolute &&
    !!applicationStatusThreshold?.placementType
  const isCompensation =
    !!applicationStatusThreshold?.placementType &&
    applicationStatusThreshold?.isCompensationThreshold
  const placedStatusText = `This rule defines when a student is considered placed, either at the   <b>‘Intent to offer’ </b> or <b> ‘Offer Acceptance’
      </b> stage. Once the set limit is reached, the student must seek approval from the Placement Officer to apply for additional roles.`
  const selectedPlacedText = `No. of  <b>${
    !applicationStatusThreshold?.placementType
      ? '‘Intent to offer’ or ‘Offer Acceptance’'
      : getPlacedStatus(applicationStatusThreshold?.placementType)
  }</b> a student can hold`

  const minimumThresholdText = `If a student is placed below the <b> 'Minimum Threshold’ </b>, they can apply for all roles. <br/>
If they are placed above the <b> 'Minimum Threshold’ </b>, they are eligible to apply for jobs based on the below rules`

  const LPADetailsText = `Here, you can establish a threshold based on either a multiple of the <b> Placed LPA </b> or an <b> absolute LPA </b> number that students must meet before they can apply for another job after reaching the <b> 'Intent to Offer' </b> or <b> ‘Offer Acceptance’ </b> stage.`
  const positionBasedDetails = `Students who are in the  <b>${
    !applicationStatusThreshold?.placementType
      ? '‘Intent to offer’ or ‘Offer Acceptance’'
      : getPlacedStatus(applicationStatusThreshold?.placementType)
  }</b> stage of the evaluation process from a lower comp. hierarchy (ex. Regular/Dream) are allowed to apply for positions at a higher comp. hierarchy (ex. Super Dream/Elite).`
  const exceptionBrandsText = `Please enter the <b> Exception Brands </b> here to override the compensation range. If jobs are posted by these companies, it will allow every student to apply regardless of the specified compensation range.`
  const isCheckAboveMinValue = ruleForm
    ?.getFieldValue(['applicationStatusThreshold', 'compensationThreshold'])
    ?.findIndex(item => {
      const minCTC = item.minCTC || 0
      const maxCTC = item.maxCTC || 0
      return (
        item?.name &&
        convertToNumber(minCTC) > 0 &&
        convertToNumber(maxCTC) === 0
      )
    })

  const isCompensationList = ruleForm.getFieldValue([
    'applicationStatusThreshold',
    'compensationThreshold',
  ])

  const onChangeHandler = (value, fieldName) => {
    const updateField = prev => ({
      ...prev,
      applicationStatusThreshold: {
        ...prev.applicationStatusThreshold,
        [fieldName]: value,
        // isEnabled: true,
        ...(fieldName === 'isMultiples' && {
          isAbsolute: false,
          offerEnabled: '',
        }),
        ...(fieldName === 'isAbsolute' && {
          isMultiples: false,
          offerEnabled: '',
        }),
        ...(fieldName === 'isCompensationThreshold' && {
          offerEnabled: '',
        }),
      },
    })

    const updatedFormValues = updateField(ruleForm.getFieldsValue())

    ruleForm.setFieldsValue(updatedFormValues)
    setState(updateField)
  }

  const handleCompensationChange = (value, index, fieldName, type) => {
    // Update form field value
    ruleForm.setFieldValue(
      ['applicationStatusThreshold', 'compensationThreshold', index, fieldName],
      value
    )

    // Update state
    setState(prevState => {
      const updatedThresholds = [
        ...prevState.applicationStatusThreshold.compensationThreshold,
      ]

      // Update the current object at the index
      updatedThresholds[index] = {
        ...updatedThresholds[index],
        [fieldName]: value,
      }

      // Check if the 'to' value is a valid number before updating the 'from' value of the next object
      if (fieldName === 'maxCTC' && index < updatedThresholds.length - 1) {
        const cleanedValue = value
        const nextFromValue = parseInt(cleanedValue, 10) // Convert 'to' to an integer safely
        let autoPopulateValue = !isNaN(nextFromValue)
          ? (nextFromValue + 1).toString()
          : 0
        updatedThresholds[index + 1] = {
          ...updatedThresholds[index + 1],
          minCTC: formatNumber(autoPopulateValue), // Set 'from' as 'to + 1'
        }

        // Also update form for the next 'from'
        ruleForm.setFieldValue(
          [
            'applicationStatusThreshold',
            'compensationThreshold',
            index + 1,
            'minCTC',
          ],
          formatNumber(autoPopulateValue)
        )
      }

      if (index === updatedThresholds.length - 1) {
        ruleForm.validateFields()
      }

      return {
        ...prevState,
        applicationStatusThreshold: {
          ...prevState.applicationStatusThreshold,
          compensationThreshold: updatedThresholds,
          // isAboveMinValue: isCheckAboveMinValue !== -1,
        },
      }
    })
  }

  const handleRemoveCompensation = (remove, index) => {
    remove(index)
    // Update the state to reset the values of the next items to initial values
    setState(prevState => {
      const updatedThresholds =
        prevState.applicationStatusThreshold.compensationThreshold.map(
          (item, idx) => {
            // If the index is less than or equal to the removed index, return the item as is
            if (idx < index) {
              return item
            }
            // Reset values for all items after the removed index
            return {
              name: item.name,
              minCTC: '',
              maxCTC: '',
              orderNo: idx + 1,
            }
          }
        )

      const finalThresholds = updatedThresholds.filter(
        (_, idx) => idx !== index
      )
      ruleForm.setFieldsValue({
        applicationStatusThreshold: {
          ...prevState.applicationStatusThreshold,
          compensationThreshold: finalThresholds,
        },
      })
      return {
        ...prevState,
        applicationStatusThreshold: {
          ...prevState.applicationStatusThreshold,
          compensationThreshold: finalThresholds,
        },
      }
    })
  }

  const handleAddCompensation = add => {
    if (add) {
      add() // Trigger form list item addition if using Ant Design's Form.List
    }
    const isAutoAmt = isCompensationList?.every(
      item => item?.name && item?.maxCTC && item?.minCTC
    )

    const dataObj = {
      name: '',
      minCTC: isAutoAmt
        ? convertToNumber(
            isCompensationList?.[isCompensationList?.length - 1]?.maxCTC
          ) + 1 || ''
        : '',
      maxCTC: '',
    }

    setState(prevState => {
      const updatedCompensationThreshold = [
        ...(prevState.applicationStatusThreshold?.compensationThreshold || []),
        dataObj,
      ]
      ruleForm.setFieldsValue({
        applicationStatusThreshold: {
          ...prevState.applicationStatusThreshold,
          compensationThreshold: updatedCompensationThreshold,
        },
      })

      return {
        ...prevState,
        applicationStatusThreshold: {
          ...prevState.applicationStatusThreshold,
          compensationThreshold: updatedCompensationThreshold,
        },
      }
    })
  }

  const fetchCorporateList = async (search = '') => {
    const response = await getListOfCompanies(search, 0)
    if (response?.companymasterData?.result?.length > 0) {
      setCorporateList(response?.companymasterData?.result || [])
    } else {
      setCorporateList([])
    }
  }

  const handleBrandChange = option => {
    let brandsList = option.map(item => ({
      corporateId: item.id,
      corporateName: item.name,
    }))
    setState({
      ...state,
      applicationStatusThreshold: {
        ...state.applicationStatusThreshold,
        exceptionBrands: brandsList,
      },
    })
  }

  const delayToFetchData = useCallback(
    Debounce(text => {
      if (text.trim() === '') {
        fetchCorporateList('')
      } else {
        fetchCorporateList(text)
      }
    }, 1000),
    []
  )

  const handleDropdownChange = open => {
    if (!open) {
      fetchCorporateList('')
    }
  }
  const handleSearch = value => {
    delayToFetchData(value)
  }

  useEffect(() => {
    fetchCorporateList('')
  }, [])

  const isAboveMinValue = applicationStatusThreshold?.isAboveMinValue

  return (
    <React.Fragment>
      <TextElement
        dangerouslySetInnerHTML={{ __html: placedStatusText }}
      ></TextElement>

      <StyledRuleRow pBottom={30}>
        <Col md={24}>
          <FormItem
            rules={[
              {
                required: true,
                message: 'Please select the placed stage',
              },
            ]}
            name={['applicationStatusThreshold', 'placementType']}
          >
            <RadioGroup
              onChange={({ target }) =>
                onChangeHandler(target.value, 'placementType')
              }
              displayFlex
              gap={'10px'}
            >
              {placedStatusOption?.map((item, index) => (
                <RadioButton
                  width={'190px'}
                  key={index + item?.value}
                  border={true}
                  label={item?.label}
                  value={item?.value}
                />
              ))}
            </RadioGroup>
          </FormItem>
        </Col>
      </StyledRuleRow>

      <StyledRuleRow pBottom={10}>
        <Col md={6}>
          <TextElement
            disabled={!applicationStatusThreshold?.placementType}
            dangerouslySetInnerHTML={{ __html: selectedPlacedText }}
          ></TextElement>
        </Col>
        <Col md={18}>
          <FormItem
            name={['applicationStatusThreshold', 'placedLimit']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    value <= 0 &&
                    applicationStatusThreshold?.placementType
                  ) {
                    return Promise.reject(
                      new Error(
                        `Please enter the no. of ${getPlacedStatus(
                          applicationStatusThreshold?.placementType
                        )} a student can hold.`
                      )
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledTextInput
              type="number"
              width="200px"
              height={'40px'}
              disabled={!applicationStatusThreshold?.placementType}
              onChange={e => onChangeHandler(e.target.value, 'placedLimit')}
              placeholder="0"
              state={
                applicationStatusThreshold?.placedLimit > 0
                  ? applicationStatusThreshold?.placedLimit
                  : ''
              }
            />
          </FormItem>
        </Col>
      </StyledRuleRow>
      <StyledRuleRow>
        <Col>
          <TextElement
            disabled={!applicationStatusThreshold?.placementType}
            dangerouslySetInnerHTML={{ __html: minimumThresholdText }}
          ></TextElement>
        </Col>
        <Col md={24}>
          <NormalTable>
            <th>
              <TextElement
                disabled={!applicationStatusThreshold?.placementType}
              >
                CTC threshold
              </TextElement>
            </th>
            <tbody>
              <tr>
                <td>
                  <div className="tableData">
                    <TextElement
                      disabled={!applicationStatusThreshold?.placementType}
                      mTop={'10px'}
                    >
                      Minimum Threshold
                    </TextElement>
                    <FormItem
                      name={['applicationStatusThreshold', 'minThreshold']}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            onChangeHandler(value, 'minThreshold')
                            if (value && value == 0) {
                              return Promise.reject(
                                new Error(`Please enter the minimum threshold`)
                              )
                            }
                            return Promise.resolve()
                          },
                        }),
                      ]}
                    >
                      <div>
                        <StyledInputNumber
                          prefix={
                            <StyledSymbolWithIcon prefixWithIcon>
                              ₹ <ArrowDownIcon style={{ marginLeft: '4px' }} />
                            </StyledSymbolWithIcon>
                          }
                          value={ruleForm.getFieldValue([
                            'applicationStatusThreshold',
                            'minThreshold',
                          ])}
                          formatter={value => formatNumber(value)}
                          disabled={!applicationStatusThreshold?.placementType}
                          parser={value => checkFormatNumber(value)}
                          style={{
                            height: '40px',
                            width: '200px',
                            background:
                              !applicationStatusThreshold?.placementType
                                ? '#FAFAFB'
                                : '#FFFFFF',
                            border: !applicationStatusThreshold?.placementType
                              ? '1px solid #E6E7EA'
                              : '1px solid #D6DBF7',
                            boxShadow:
                              !applicationStatusThreshold?.placementType
                                ? 'unset'
                                : ' 0px 2px 6px 0px #7b61ff26',
                          }}
                          onChange={value =>
                            onChangeHandler(value, 'minThreshold')
                          }
                          height={'37px'}
                          placeholder="0"
                        />
                      </div>
                    </FormItem>
                  </div>
                </td>
              </tr>
            </tbody>
          </NormalTable>
        </Col>
      </StyledRuleRow>
      <StyledHr />
      <StyledRuleRow>
        <StyledRuleCol md={24} mBottom={20}>
          <TextElement
            disabled={!applicationStatusThreshold?.placementType}
            dangerouslySetInnerHTML={{ __html: LPADetailsText }}
          ></TextElement>
        </StyledRuleCol>
        <Col md={24}>
          <StyledRuleRow pBottom={20}>
            <Col md={6}>
              <Checkbox
                onChange={e => onChangeHandler(e.target.checked, 'isMultiples')}
                checked={applicationStatusThreshold?.isMultiples}
                disabled={!applicationStatusThreshold?.placementType}
              >
                Enter Multiples
              </Checkbox>
            </Col>
            <Col md={8}>
              <FormItem
                rules={[
                  () => ({
                    validator(_, value) {
                      if (
                        applicationStatusThreshold?.isMultiples &&
                        (!value || value == '' || value == 0)
                      ) {
                        return Promise.reject(
                          new Error(`Please enter the value`)
                        )
                      }
                      return Promise.resolve()
                    },
                  }),
                ]}
                name={['applicationStatusThreshold', 'multiplesThreshold']}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      visibility: 'hidden',
                    }}
                  >
                    ≥
                  </div>
                  <StyledTextInput
                    type="number"
                    width="200px"
                    height={'40px'}
                    disabled={!isMultiplesLPA}
                    onChange={e =>
                      onChangeHandler(e.target.value, 'multiplesThreshold')
                    }
                    placeholder="0"
                    value={
                      state.applicationStatusThreshold?.multiplesThreshold > 0
                        ? state.applicationStatusThreshold?.multiplesThreshold
                        : ''
                    }
                  />
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: !isMultiplesLPA ? '#8A8A8A' : '#000',
                    }}
                  >
                    X
                  </div>
                </div>
              </FormItem>
            </Col>
          </StyledRuleRow>
        </Col>

        <Col md={24}>
          <Row>
            <Col md={6}>
              <Checkbox
                onChange={e => onChangeHandler(e.target.checked, 'isAbsolute')}
                checked={applicationStatusThreshold?.isAbsolute}
                disabled={!applicationStatusThreshold?.placementType}
              >
                Absolute number
              </Checkbox>
            </Col>

            <Col md={8}>
              <FormItem
                name={['applicationStatusThreshold', 'absoluteThreshold']}
                rules={[
                  () => ({
                    validator(_, value) {
                      onChangeHandler(value, 'absoluteThreshold')
                      if (
                        applicationStatusThreshold?.isAbsolute &&
                        (!value || value == '' || value == 0)
                      ) {
                        return Promise.reject(
                          new Error(`Please enter the value`)
                        )
                      }
                      return Promise.resolve()
                    },
                  }),
                ]}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: !isAbsoluteLAP ? '#8A8A8A' : '#000',
                    }}
                  >
                    ≥
                  </div>
                  <StyledInputNumber
                    height={'37px'}
                    disabled={!isAbsoluteLAP}
                    prefix={
                      <StyledSymbolWithIcon prefixWithIcon>
                        ₹ <ArrowDownIcon style={{ marginLeft: '4px' }} />
                      </StyledSymbolWithIcon>
                    }
                    parser={value => checkFormatNumber(value)}
                    formatter={value => formatNumber(value)}
                    onChange={value =>
                      onChangeHandler(value, 'absoluteThreshold')
                    }
                    value={ruleForm.getFieldValue([
                      'applicationStatusThreshold',
                      'absoluteThreshold',
                    ])}
                    placeholder="0"
                    style={{
                      height: '40px',
                      width: '200px',
                      background: !isAbsoluteLAP ? '#FAFAFB' : '#FFFFFF',
                      border: !isAbsoluteLAP
                        ? '1px solid #E6E7EA'
                        : '1px solid #D6DBF7',
                      boxShadow: !isAbsoluteLAP
                        ? 'unset'
                        : ' 0px 2px 6px 0px #7b61ff26',
                    }}
                    width={'200px'}
                  />
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      visibility: 'hidden',
                    }}
                  >
                    X
                  </div>
                </div>
              </FormItem>
            </Col>
          </Row>
        </Col>
      </StyledRuleRow>
      <StyledHr />
      <StyledRuleRow>
        <StyledRuleCol>
          <Checkbox
            onChange={e =>
              onChangeHandler(e.target.checked, 'isCompensationThreshold')
            }
            checked={applicationStatusThreshold?.isCompensationThreshold}
            disabled={!applicationStatusThreshold?.placementType}
          >
            Compensation Threshold
          </Checkbox>{' '}
          <br />
          <TextElement
            mTop={'15px'}
            disabled={!applicationStatusThreshold?.placementType}
          >
            Establish the threshold for Comp. range for each type.
          </TextElement>
        </StyledRuleCol>
        <Col>
          <FormItem
            name="compensationThreshold"
            initialValues={{
              applicationStatusThreshold: {
                compensationThreshold:
                  state?.applicationStatusThreshold?.compensationThreshold,
                isAboveMinValue:
                  state?.applicationStatusThreshold?.isAboveMinValue,
              },
            }}
          >
            <Form.List
              name={['applicationStatusThreshold', 'compensationThreshold']}
            >
              {(fields, { add, remove }, { errors }) =>
                fields.map((field, index) => {
                  return (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '1em',
                          paddingBottom: 25,
                        }}
                      >
                        <FormItem
                          required={false}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator: (_, value) => {
                                const compensationList = getFieldValue([
                                  'applicationStatusThreshold',
                                  'compensationThreshold',
                                ])

                                const isNameDuplicate = compensationList.some(
                                  (name, i) => {
                                    return name.name === value && i !== index
                                  }
                                )
                                if (isNameDuplicate && value) {
                                  return Promise.reject(
                                    'This name is already taken'
                                  )
                                }
                                if (
                                  applicationStatusThreshold?.isCompensationThreshold &&
                                  (value == 0 || !value)
                                ) {
                                  return Promise.reject(
                                    new Error(`please fill the  name`)
                                  )
                                }
                                return Promise.resolve()
                              },
                            }),
                          ]}
                          name={[field.name, 'name']}
                        >
                          <StyledTextInput
                            type="text"
                            width="110px"
                            height={'40px'}
                            disabled={!isCompensation}
                            onChange={e =>
                              handleCompensationChange(
                                e.target.value,
                                index,
                                'name'
                              )
                            }
                            autoComplete="off" // Prevent browser autofill
                            orderNo={index + 1}
                          />
                        </FormItem>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <FormItem
                            required={false}
                            name={[field.name, 'minCTC']}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const previousCompensationThresholds =
                                    getFieldValue([
                                      'applicationStatusThreshold',
                                      'compensationThreshold',
                                    ])
                                  const numericValue =
                                    convertToNumber(value) || 0

                                  if (
                                    applicationStatusThreshold?.isCompensationThreshold &&
                                    (value == 0 || !value)
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        `Please enter the minimum threshold`
                                      )
                                    )
                                  }

                                  if (index > 0) {
                                    const previousMaxCTC =
                                      previousCompensationThresholds[index - 1]
                                        ?.maxCTC
                                    const previousMaxCTCValue =
                                      convertToNumber(previousMaxCTC) || 0
                                    if (numericValue <= previousMaxCTCValue) {
                                      if (numericValue > 0) {
                                        return Promise.reject(
                                          new Error(
                                            `Please enter the valid CTC`
                                          )
                                        )
                                      }
                                    }
                                  }
                                  return Promise.resolve()
                                },
                              }),
                            ]}
                          >
                            <div>
                              <StyledInputNumber
                                width="275px"
                                height={'40px'}
                                disabled={!isCompensation}
                                style={{
                                  height: '40px',
                                  width: '275px',
                                  background: !isCompensation
                                    ? '#FAFAFB'
                                    : '#FFFFFF',
                                  border: !isCompensation
                                    ? '1px solid #E6E7EA'
                                    : '1px solid #D6DBF7',
                                  boxShadow: !isCompensation
                                    ? 'unset'
                                    : ' 0px 2px 6px 0px #7b61ff26',
                                }}
                                value={ruleForm.getFieldValue([
                                  'applicationStatusThreshold',
                                  'compensationThreshold',
                                  field.name,
                                  'minCTC',
                                ])}
                                formatter={value => formatNumber(value)}
                                parser={value => checkFormatNumber(value)}
                                prefix={
                                  <StyledSymbolWithIcon prefixWithIcon>
                                    ₹{' '}
                                    <ArrowDownIcon
                                      style={{ marginLeft: '4px' }}
                                    />
                                  </StyledSymbolWithIcon>
                                }
                                onChange={value =>
                                  handleCompensationChange(
                                    value,
                                    index,
                                    'minCTC',
                                    'number'
                                  )
                                }
                                placeholder="0"
                              />
                            </div>
                          </FormItem>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              height: 40,
                            }}
                          >
                            -
                          </div>
                          <FormItem
                            required={false}
                            name={[field.name, 'maxCTC']}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const previousCompensationThresholds =
                                    getFieldValue([
                                      'applicationStatusThreshold',
                                      'compensationThreshold',
                                    ])

                                  const numericValue =
                                    convertToNumber(value) || 0
                                  if (
                                    applicationStatusThreshold?.isCompensationThreshold &&
                                    (value == 0 || !value)
                                  ) {
                                    if (
                                      isAboveMinValue &&
                                      index ===
                                        previousCompensationThresholds?.length -
                                          1
                                    ) {
                                      return Promise.resolve()
                                    } else {
                                      return Promise.reject(
                                        new Error(
                                          `Please enter the maximum threshold`
                                        )
                                      )
                                    }
                                  }

                                  if (numericValue) {
                                    const minCTC =
                                      previousCompensationThresholds[index]
                                        ?.minCTC
                                    const minCTCValue =
                                      convertToNumber(minCTC) || 0

                                    if (minCTCValue >= numericValue) {
                                      return Promise.reject(
                                        new Error(`Please enter the valid CTC`)
                                      )
                                    }
                                  }

                                  return Promise.resolve()
                                },
                              }),
                            ]}
                          >
                            <div>
                              <StyledInputNumber
                                width="275px"
                                height={'40px'}
                                value={ruleForm.getFieldValue([
                                  'applicationStatusThreshold',
                                  'compensationThreshold',
                                  field.name,
                                  'maxCTC',
                                ])}
                                disabled={!isCompensation}
                                style={{
                                  height: '40px',
                                  width: '275px',
                                  background: !isCompensation
                                    ? '#FAFAFB'
                                    : '#FFFFFF',
                                  border: !isCompensation
                                    ? '1px solid #E6E7EA'
                                    : '1px solid #D6DBF7',
                                  boxShadow: !isCompensation
                                    ? 'unset'
                                    : ' 0px 2px 6px 0px #7b61ff26',
                                }}
                                formatter={value => formatNumber(value)}
                                parser={value => checkFormatNumber(value)}
                                prefix={
                                  <StyledSymbolWithIcon prefixWithIcon>
                                    ₹{' '}
                                    <ArrowDownIcon
                                      style={{ marginLeft: '4px' }}
                                    />
                                  </StyledSymbolWithIcon>
                                }
                                onChange={value =>
                                  handleCompensationChange(
                                    value,
                                    index,
                                    'maxCTC',
                                    'number'
                                  )
                                }
                                placeholder="0"
                              />
                            </div>
                          </FormItem>
                        </div>
                        <EmptyDivElement
                          onClick={() =>
                            handleRemoveCompensation(remove, index)
                          }
                          style={{ marginTop: 7 }}
                        >
                          <DeleteIcon />
                        </EmptyDivElement>
                      </div>
                      {fields.length === index + 1 && (
                        <CheckBoxContainer>
                          <FormItem
                            name={[
                              'applicationStatusThreshold',
                              'isAboveMinValue',
                            ]}
                            rules={[
                              () => ({
                                validator() {
                                  if (
                                    isCheckAboveMinValue !== -1 &&
                                    !applicationStatusThreshold?.isAboveMinValue &&
                                    applicationStatusThreshold?.isCompensationThreshold
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        `Please check the anything above minimum value`
                                      )
                                    )
                                  }
                                  return Promise.resolve()
                                },
                              }),
                            ]}
                          >
                            <Checkbox
                              onChange={async e => {
                                onChangeHandler(
                                  e.target.checked,
                                  'isAboveMinValue'
                                )
                                ruleForm.validateFields()
                              }}
                              checked={
                                applicationStatusThreshold?.isAboveMinValue
                              }
                              value={
                                applicationStatusThreshold?.isAboveMinValue
                              }
                              disabled={
                                !applicationStatusThreshold?.placementType ||
                                isCheckAboveMinValue === -1
                              }
                            >
                              Anything above minimum value
                            </Checkbox>
                          </FormItem>
                          <EmptyDivElement>
                            <Button.Primary
                              height={'38px'}
                              text={'Add more'}
                              icon={<PlusIcon />}
                              disabled={index === 9}
                              onClick={() => handleAddCompensation(add)}
                            />
                          </EmptyDivElement>
                        </CheckBoxContainer>
                      )}
                    </>
                  )
                })
              }
            </Form.List>
          </FormItem>
        </Col>
        <Col xs={24}>
          {isCompensationList?.length === 0 ? (
            <EmptyDivElement>
              <Button.Primary
                height={'38px'}
                text={'Add more'}
                icon={<PlusIcon />}
                onClick={() => handleAddCompensation()}
              />
            </EmptyDivElement>
          ) : null}
        </Col>
      </StyledRuleRow>
      <StyledHr />
      <StyledRuleRow>
        <Col>
          <TextElement
            dangerouslySetInnerHTML={{ __html: positionBasedDetails }}
            disabled={!applicationStatusThreshold?.placementType}
          ></TextElement>
          <FormItem
            rules={[
              {
                required: applicationStatusThreshold?.isCompensationThreshold,
                message:
                  'Please select an action for the higher compensation hierarchy.',
              },
            ]}
            name={['applicationStatusThreshold', 'offerEnabled']}
          >
            <RadioGroup
              onChange={({ target }) =>
                onChangeHandler(target.value, 'offerEnabled')
              }
              displayFlex
              gap={'10px'}
            >
              {positionBasedOption?.map((item, index) => (
                <RadioButton
                  width={'190px'}
                  key={index + item?.value}
                  border={true}
                  label={item?.label}
                  value={item?.value}
                  disabled={
                    !applicationStatusThreshold?.placementType ||
                    (index === 0 &&
                      (applicationStatusThreshold?.isAbsolute ||
                        applicationStatusThreshold?.isMultiples)) ||
                    !applicationStatusThreshold?.isCompensationThreshold
                  }
                />
              ))}
            </RadioGroup>
          </FormItem>
        </Col>
      </StyledRuleRow>
      <StyledHr />
      <StyledRuleRow>
        <Col>
          <TextElement
            dangerouslySetInnerHTML={{ __html: exceptionBrandsText }}
            disabled={!applicationStatusThreshold?.placementType}
          ></TextElement>
        </Col>
        <Col>
          <Row gutter={30} align="center">
            <Col>
              <TextElement
                disabled={!applicationStatusThreshold?.placementType}
              >
                Exception Brands
              </TextElement>
            </Col>
            <Col>
              <Select
                showSearch={true}
                OptionData={corporateList ?? []}
                label={''}
                valueParam="id"
                nameParam={'companyName'}
                placeholder="Search for brands"
                mode={'multiple'}
                onChange={(value, option) => handleBrandChange(option)}
                onSearch={handleSearch}
                filterOption={false}
                defaultValue={
                  state?.applicationStatusThreshold?.exceptionBrands?.map(
                    item => item.corporateId
                  ) || []
                }
                listHeight={170}
                width={'586px'}
                onDropdownVisibleChange={handleDropdownChange}
                disabled={!applicationStatusThreshold?.placementType}
                notFoundContent={
                  loading ? <Spin size="small" /> : 'No Data Found'
                }
                maxTagCount={3}
              />
            </Col>
          </Row>
        </Col>
      </StyledRuleRow>
    </React.Fragment>
  )
}
